import Field from 'Components/Organisms/Field/Field';
import React from 'react';
import { FieldType } from 'Store/FieldManagement/PropTypes';
import './search-users.scss';

export interface SearchUsersProps {
    searchFilter: any
    onChange: any
}

export const SearchUsers = ({searchFilter, onChange}: SearchUsersProps) => {
    return <div style={{marginBottom: '16px'}}>
        <Field
            isEdit={true}
            type={FieldType.Text}
            value={searchFilter}
            onChange={onChange}
            properties={{
                placeholder: 'Zoeken...'
            }}
        />
    </div>;
}
